import * as types from "~/store/fee/feeTypes";

export const changeFeeCode = hosNumber => ({
  type: types.CHANGE_FEE_CODE,
  hosNumber
});

export const searchFeeCode = () => {
  return {
    type: types.SEARCH_FEE_CODE
  };
};

export const selectFee = fee => {
  return {
    type: types.SELECT_FEE,
    payload: fee
  };
};

export const clearDataSearchFeeCode = () => {
  return {
    type: types.CLEAR_DATA_SEARCH_FEE_CODE
  };
};

export const onChangeEmail = value => {
  return {
    type: types.ON_CHANGE_EMAIL,
    payload: value
  };
};

export const paymentFee = () => {
  return {
    type: types.REQUEST_PAYMENT_FEE
  };
};

// -------------------------------

export const changeReceiptNumber = receiptNumber => ({
  type: types.CHANGE_RECEIPT_NUMBER,
  receiptNumber
});
export const selectMethodNBank = selectedMethodNBank => ({
  type: types.SELECT_METHOD_AND_BANK,
  selectedMethodNBank
});
export const changePatientNumber = patientNumber => ({
  type: types.CHANGE_PATIENT_NUMBER,
  patientNumber
});
export const clearState = () => ({ type: types.CLEAR_STATE });
export const changeSearchTab = searchTab => ({
  type: types.CHANGE_SEARCH_TAB,
  searchTab
});
export const changePayIdList = (id, actionType) => ({
  type: types.CHANGE_PAY_ID_LIST,
  id,
  actionType
});

export const getAllFee = data => ({ type: types.GET_ALL_FEE_REQUEST, data });
export const getBank = data => ({ type: types.GET_BANK_REQUEST, data });
export const getOrder = data => ({ type: types.GET_ORDER_REQUEST, data });
export const getOrderOffline = data => ({
  type: types.GET_ORDER_OFFLINE_REQUEST,
  data
});

export const getFeesHistory = data => {
  return {
    type: types.GET_FEES_HISTORY,
    data
  };
};

export const showErrorMessage = errorMessage => ({
  type: types.GET_ORDER_FAILURE,
  errorMessage
});

export const getAllPaymentMethod = data => ({
  type: types.GET_ALL_PAYMENT_METHOD,
  data
});

export const getHistoryPayment = () => {
  return {
    type: types.GET_HISTORY_PAYMENT
  };
};

